import React from 'react';
import spinnerImgSrc from '../../../images/spinner.svg';

import './Spinner.less';

const Spinner = ({isLoading}) => {
    if (isLoading) {
        return (
            <img
                alt="Loading"
                className="Spinner__Image"
                data-testid="Spinner"
                src={spinnerImgSrc()}
            />
        );
    }
    return null;
};

export default Spinner;
